import styled, { css, ThemeProvider } from 'styled-components';
export { ServerStyleSheet, StyleSheetManager, ThemeConsumer, createGlobalStyle, css, isStyledComponent, keyframes, default as styled, withTheme } from 'styled-components';
import { theme as theme$1 } from 'styled-tools';
export { ifNotProp, ifProp, palette, prop, switchProp, theme, withProp } from 'styled-tools';
import use from 'reuse';
export { default as use } from 'reuse';
import React__default, { forwardRef, createElement, Fragment, Component, useLayoutEffect, useState, useCallback } from 'react';
import isPropValid from '@emotion/is-prop-valid';
import { node, bool, object } from 'prop-types';
import { tint, shade, readableColor, lighten, darken } from 'polished';
import _get from 'lodash/get';
import _camelCase from 'lodash/camelCase';
import ReactDOM from 'react-dom';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}

function applyAllRefs() {
  var refs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    refs[_i] = arguments[_i];
  }

  var validRefs = refs.filter(Boolean);
  if (!validRefs.length) return undefined;
  return function (element) {
    for (var _i = 0, validRefs_1 = validRefs; _i < validRefs_1.length; _i++) {
      var value = validRefs_1[_i];

      if (typeof value === "object") {
        // @ts-ignore
        value.current = element;
      } else if (typeof value === "function") {
        value(element);
      }
    }
  };
}

var CSSProps = {
  alignContent: 'align-content',
  alignSelf: 'align-self',
  alignItems: 'align-items',
  alignmentBaseline: 'alignment-baseline',
  all: 'all',
  animation: 'animation',
  animationDelay: 'animation-delay',
  animationDirection: 'animation-direction',
  animationDuration: 'animation-duration',
  animationFillMode: 'animation-fill-mode',
  animationIterationCount: 'animation-iteration-count',
  animationName: 'animation-name',
  animationPlayState: 'animation-play-state',
  animationTimingFunction: 'animation-timing-function',
  appearance: 'appearance',
  azimuth: 'azimuth',
  backfaceVisibility: 'backface-visibility',
  background: 'background',
  backgroundAttachment: 'background-attachment',
  backgroundBlendMode: 'background-blend-mode',
  backgroundClip: 'background-clip',
  backgroundColor: 'background-color',
  backgroundImage: 'background-image',
  backgroundImageTransform: 'background-image-transform',
  backgroundOrigin: 'background-origin',
  backgroundPosition: 'background-position',
  backgroundRepeat: 'background-repeat',
  backgroundSize: 'background-size',
  baselineShift: 'baseline-shift',
  blockSize: 'block-size',
  blockStep: 'block-step',
  blockStepAlign: 'block-step-align',
  blockStepInsert: 'block-step-insert',
  blockStepRound: 'block-step-round',
  blockStepSize: 'block-step-size',
  bookmarkLabel: 'bookmark-label',
  bookmarkLevel: 'bookmark-level',
  bookmarkState: 'bookmark-state',
  border: 'border',
  borderBlock: 'border-block',
  borderBlockColor: 'border-block-color',
  borderBlockEnd: 'border-block-end',
  borderBlockEndColor: 'border-block-end-color',
  borderBlockEndStyle: 'border-block-end-style',
  borderBlockEndWidth: 'border-block-end-width',
  borderBlockStart: 'border-block-start',
  borderBlockStartColor: 'border-block-start-color',
  borderBlockStartStyle: 'border-block-start-style',
  borderBlockStartWidth: 'border-block-start-width',
  borderBlockStyle: 'border-block-style',
  borderBlockWidth: 'border-block-width',
  borderBottom: 'border-bottom',
  borderBottomColor: 'border-bottom-color',
  borderBottomLeftRadius: 'border-bottom-left-radius',
  borderBottomRightRadius: 'border-bottom-right-radius',
  borderBottomStyle: 'border-bottom-style',
  borderBottomWidth: 'border-bottom-width',
  borderBoundary: 'border-boundary',
  borderCollapse: 'border-collapse',
  borderColor: 'border-color',
  borderImage: 'border-image',
  borderImageOutset: 'border-image-outset',
  borderImageRepeat: 'border-image-repeat',
  borderImageSlice: 'border-image-slice',
  borderImageSource: 'border-image-source',
  borderImageTransform: 'border-image-transform',
  borderImageWidth: 'border-image-width',
  borderInline: 'border-inline',
  borderInlineColor: 'border-inline-color',
  borderInlineEnd: 'border-inline-end',
  borderInlineEndColor: 'border-inline-end-color',
  borderInlineEndStyle: 'border-inline-end-style',
  borderInlineEndWidth: 'border-inline-end-width',
  borderInlineStart: 'border-inline-start',
  borderInlineStartColor: 'border-inline-start-color',
  borderInlineStartStyle: 'border-inline-start-style',
  borderInlineStartWidth: 'border-inline-start-width',
  borderInlineStyle: 'border-inline-style',
  borderInlineWidth: 'border-inline-width',
  borderLeft: 'border-left',
  borderLeftColor: 'border-left-color',
  borderLeftStyle: 'border-left-style',
  borderLeftWidth: 'border-left-width',
  borderRadius: 'border-radius',
  borderRight: 'border-right',
  borderRightColor: 'border-right-color',
  borderRightStyle: 'border-right-style',
  borderRightWidth: 'border-right-width',
  borderSpacing: 'border-spacing',
  borderStyle: 'border-style',
  borderTop: 'border-top',
  borderTopColor: 'border-top-color',
  borderTopLeftRadius: 'border-top-left-radius',
  borderTopRightRadius: 'border-top-right-radius',
  borderTopStyle: 'border-top-style',
  borderTopWidth: 'border-top-width',
  borderWidth: 'border-width',
  bottom: 'bottom',
  boxDecorationBreak: 'box-decoration-break',
  boxShadow: 'box-shadow',
  boxSizing: 'box-sizing',
  boxSnap: 'box-snap',
  breakAfter: 'break-after',
  breakBefore: 'break-before',
  breakInside: 'break-inside',
  captionSide: 'caption-side',
  caret: 'caret',
  caretAnimation: 'caret-animation',
  caretColor: 'caret-color',
  caretShape: 'caret-shape',
  chains: 'chains',
  clear: 'clear',
  clip: 'clip',
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  color: 'color',
  colorAdjust: 'color-adjust',
  colorInterpolationFilters: 'color-interpolation-filters',
  columnCount: 'column-count',
  columnFill: 'column-fill',
  columnGap: 'column-gap',
  columnRule: 'column-rule',
  columnRuleColor: 'column-rule-color',
  columnRuleStyle: 'column-rule-style',
  columnRuleWidth: 'column-rule-width',
  columnSpan: 'column-span',
  columnWidth: 'column-width',
  columns: 'columns',
  contain: 'contain',
  content: 'content',
  continue: 'continue',
  counterIncrement: 'counter-increment',
  counterReset: 'counter-reset',
  counterSet: 'counter-set',
  cue: 'cue',
  cueAfter: 'cue-after',
  cueBefore: 'cue-before',
  cursor: 'cursor',
  direction: 'direction',
  display: 'display',
  dominantBaseline: 'dominant-baseline',
  elevation: 'elevation',
  emptyCells: 'empty-cells',
  fill: 'fill',
  fillBreak: 'fill-break',
  fillColor: 'fill-color',
  fillImage: 'fill-image',
  fillOpacity: 'fill-opacity',
  fillOrigin: 'fill-origin',
  fillPosition: 'fill-position',
  fillRepeat: 'fill-repeat',
  fillRule: 'fill-rule',
  fillSize: 'fill-size',
  filter: 'filter',
  flex: 'flex',
  flexBasis: 'flex-basis',
  flexDirection: 'flex-direction',
  flexFlow: 'flex-flow',
  flexGrow: 'flex-grow',
  flexShrink: 'flex-shrink',
  flexWrap: 'flex-wrap',
  float: 'float',
  floatDefer: 'float-defer',
  floatOffset: 'float-offset',
  floatReference: 'float-reference',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  flow: 'flow',
  flowFrom: 'flow-from',
  flowInto: 'flow-into',
  font: 'font',
  fontFamily: 'font-family',
  fontFeatureSettings: 'font-feature-settings',
  fontKerning: 'font-kerning',
  fontLanguageOverride: 'font-language-override',
  fontMaxSize: 'font-max-size',
  fontMinSize: 'font-min-size',
  fontOpticalSizing: 'font-optical-sizing',
  fontPalette: 'font-palette',
  fontPresentation: 'font-presentation',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontSynthesis: 'font-synthesis',
  fontVariant: 'font-variant',
  fontVariantAlternates: 'font-variant-alternates',
  fontVariantCaps: 'font-variant-caps',
  fontVariantEastAsian: 'font-variant-east-asian',
  fontVariantLigatures: 'font-variant-ligatures',
  fontVariantNumeric: 'font-variant-numeric',
  fontVariantPosition: 'font-variant-position',
  fontVariationSettings: 'font-variation-settings',
  fontWeight: 'font-weight',
  footnoteDisplay: 'footnote-display',
  footnotePolicy: 'footnote-policy',
  gap: 'gap',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  grid: 'grid',
  gridArea: 'grid-area',
  gridAutoColumns: 'grid-auto-columns',
  gridAutoFlow: 'grid-auto-flow',
  gridAutoRows: 'grid-auto-rows',
  gridColumn: 'grid-column',
  gridColumnEnd: 'grid-column-end',
  gridColumnGap: 'grid-column-gap',
  gridColumnStart: 'grid-column-start',
  gridGap: 'grid-gap',
  gridRow: 'grid-row',
  gridRowEnd: 'grid-row-end',
  gridRowGap: 'grid-row-gap',
  gridRowStart: 'grid-row-start',
  gridTemplate: 'grid-template',
  gridTemplateAreas: 'grid-template-areas',
  gridTemplateColumns: 'grid-template-columns',
  gridTemplateRows: 'grid-template-rows',
  hangingPunctuation: 'hanging-punctuation',
  height: 'height',
  hyphenateCharacter: 'hyphenate-character',
  hyphenateLimitChars: 'hyphenate-limit-chars',
  hyphenateLimitLast: 'hyphenate-limit-last',
  hyphenateLimitLines: 'hyphenate-limit-lines',
  hyphenateLimitZone: 'hyphenate-limit-zone',
  hyphens: 'hyphens',
  imageOrientation: 'image-orientation',
  imageResolution: 'image-resolution',
  initialLetter: 'initial-letter',
  initialLetterAlign: 'initial-letter-align',
  initialLetterWrap: 'initial-letter-wrap',
  inlineSize: 'inline-size',
  inset: 'inset',
  insetBlock: 'inset-block',
  insetBlockEnd: 'inset-block-end',
  insetBlockStart: 'inset-block-start',
  insetInline: 'inset-inline',
  insetInlineEnd: 'inset-inline-end',
  insetInlineStart: 'inset-inline-start',
  isolation: 'isolation',
  justifyContent: 'justify-content',
  justifyItems: 'justify-items',
  justifySelf: 'justify-self',
  left: 'left',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  lineBreak: 'line-break',
  lineGrid: 'line-grid',
  lineHeight: 'line-height',
  lineHeightStep: 'line-height-step',
  lineSnap: 'line-snap',
  listStyle: 'list-style',
  listStyleImage: 'list-style-image',
  listStylePosition: 'list-style-position',
  listStyleType: 'list-style-type',
  margin: 'margin',
  marginBlock: 'margin-block',
  marginBlockEnd: 'margin-block-end',
  marginBlockStart: 'margin-block-start',
  marginBottom: 'margin-bottom',
  marginInline: 'margin-inline',
  marginInlineEnd: 'margin-inline-end',
  marginInlineStart: 'margin-inline-start',
  marginLeft: 'margin-left',
  marginRight: 'margin-right',
  marginTop: 'margin-top',
  marker: 'marker',
  markerEnd: 'marker-end',
  markerKnockoutLeft: 'marker-knockout-left',
  markerKnockoutRight: 'marker-knockout-right',
  markerMid: 'marker-mid',
  markerPattern: 'marker-pattern',
  markerSegment: 'marker-segment',
  markerSide: 'marker-side',
  markerStart: 'marker-start',
  marqueeDirection: 'marquee-direction',
  marqueeLoop: 'marquee-loop',
  marqueeSpeed: 'marquee-speed',
  marqueeStyle: 'marquee-style',
  mask: 'mask',
  maskBorder: 'mask-border',
  maskBorderMode: 'mask-border-mode',
  maskBorderOutset: 'mask-border-outset',
  maskBorderRepeat: 'mask-border-repeat',
  maskBorderSlice: 'mask-border-slice',
  maskBorderSource: 'mask-border-source',
  maskBorderWidth: 'mask-border-width',
  maskClip: 'mask-clip',
  maskComposite: 'mask-composite',
  maskImage: 'mask-image',
  maskMode: 'mask-mode',
  maskOrigin: 'mask-origin',
  maskPosition: 'mask-position',
  maskRepeat: 'mask-repeat',
  maskSize: 'mask-size',
  maskType: 'mask-type',
  maxBlockSize: 'max-block-size',
  maxHeight: 'max-height',
  maxInlineSize: 'max-inline-size',
  maxLines: 'max-lines',
  maxWidth: 'max-width',
  minBlockSize: 'min-block-size',
  minHeight: 'min-height',
  minInlineSize: 'min-inline-size',
  minWidth: 'min-width',
  mixBlendMode: 'mix-blend-mode',
  navDown: 'nav-down',
  navLeft: 'nav-left',
  navRight: 'nav-right',
  navUp: 'nav-up',
  objectFit: 'object-fit',
  objectPosition: 'object-position',
  offset: 'offset',
  offsetAfter: 'offset-after',
  offsetAnchor: 'offset-anchor',
  offsetBefore: 'offset-before',
  offsetDistance: 'offset-distance',
  offsetEnd: 'offset-end',
  offsetPath: 'offset-path',
  offsetPosition: 'offset-position',
  offsetRotate: 'offset-rotate',
  offsetStart: 'offset-start',
  opacity: 'opacity',
  order: 'order',
  orphans: 'orphans',
  outline: 'outline',
  outlineColor: 'outline-color',
  outlineOffset: 'outline-offset',
  outlineStyle: 'outline-style',
  outlineWidth: 'outline-width',
  overflow: 'overflow',
  overflowStyle: 'overflow-style',
  overflowWrap: 'overflow-wrap',
  overflowX: 'overflow-x',
  overflowY: 'overflow-y',
  padding: 'padding',
  paddingBlock: 'padding-block',
  paddingBlockEnd: 'padding-block-end',
  paddingBlockStart: 'padding-block-start',
  paddingBottom: 'padding-bottom',
  paddingInline: 'padding-inline',
  paddingInlineEnd: 'padding-inline-end',
  paddingInlineStart: 'padding-inline-start',
  paddingLeft: 'padding-left',
  paddingRight: 'padding-right',
  paddingTop: 'padding-top',
  page: 'page',
  pageBreakAfter: 'page-break-after',
  pageBreakBefore: 'page-break-before',
  pageBreakInside: 'page-break-inside',
  pause: 'pause',
  pauseAfter: 'pause-after',
  pauseBefore: 'pause-before',
  perspective: 'perspective',
  perspectiveOrigin: 'perspective-origin',
  pitch: 'pitch',
  pitchRange: 'pitch-range',
  placeContent: 'place-content',
  placeItems: 'place-items',
  placeSelf: 'place-self',
  playDuring: 'play-during',
  pointerEvents: 'pointer-events',
  position: 'position',
  presentationLevel: 'presentation-level',
  quotes: 'quotes',
  regionFragment: 'region-fragment',
  resize: 'resize',
  rest: 'rest',
  restAfter: 'rest-after',
  restBefore: 'rest-before',
  richness: 'richness',
  right: 'right',
  rotation: 'rotation',
  rotationPoint: 'rotation-point',
  rowGap: 'row-gap',
  rubyAlign: 'ruby-align',
  rubyMerge: 'ruby-merge',
  rubyPosition: 'ruby-position',
  running: 'running',
  scrollBehavior: 'scroll-behavior',
  scrollPadding: 'scroll-padding',
  scrollPaddingBlock: 'scroll-padding-block',
  scrollPaddingBlockEnd: 'scroll-padding-block-end',
  scrollPaddingBlockStart: 'scroll-padding-block-start',
  scrollPaddingBottom: 'scroll-padding-bottom',
  scrollPaddingInline: 'scroll-padding-inline',
  scrollPaddingInlineEnd: 'scroll-padding-inline-end',
  scrollPaddingInlineStart: 'scroll-padding-inline-start',
  scrollPaddingLeft: 'scroll-padding-left',
  scrollPaddingRight: 'scroll-padding-right',
  scrollPaddingTop: 'scroll-padding-top',
  scrollSnapAlign: 'scroll-snap-align',
  scrollSnapMargin: 'scroll-snap-margin',
  scrollSnapMarginBlock: 'scroll-snap-margin-block',
  scrollSnapMarginBlockEnd: 'scroll-snap-margin-block-end',
  scrollSnapMarginBlockStart: 'scroll-snap-margin-block-start',
  scrollSnapMarginBottom: 'scroll-snap-margin-bottom',
  scrollSnapMarginInline: 'scroll-snap-margin-inline',
  scrollSnapMarginInlineEnd: 'scroll-snap-margin-inline-end',
  scrollSnapMarginInlineStart: 'scroll-snap-margin-inline-start',
  scrollSnapMarginLeft: 'scroll-snap-margin-left',
  scrollSnapMarginRight: 'scroll-snap-margin-right',
  scrollSnapMarginTop: 'scroll-snap-margin-top',
  scrollSnapStop: 'scroll-snap-stop',
  scrollSnapType: 'scroll-snap-type',
  scrollbarGutter: 'scrollbar-gutter',
  shapeImageThreshold: 'shape-image-threshold',
  shapeInside: 'shape-inside',
  shapeMargin: 'shape-margin',
  shapeOutside: 'shape-outside',
  size: 'size',
  speak: 'speak',
  speakAs: 'speak-as',
  speakHeader: 'speak-header',
  speakNumeral: 'speak-numeral',
  speakPunctuation: 'speak-punctuation',
  speechRate: 'speech-rate',
  stress: 'stress',
  stringSet: 'string-set',
  stroke: 'stroke',
  strokeAlign: 'stroke-align',
  strokeAlignment: 'stroke-alignment',
  strokeBreak: 'stroke-break',
  strokeColor: 'stroke-color',
  strokeDashCorner: 'stroke-dash-corner',
  strokeDashJustify: 'stroke-dash-justify',
  strokeDashadjust: 'stroke-dashadjust',
  strokeDasharray: 'stroke-dasharray',
  strokeDashcorner: 'stroke-dashcorner',
  strokeDashoffset: 'stroke-dashoffset',
  strokeImage: 'stroke-image',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeOrigin: 'stroke-origin',
  strokePosition: 'stroke-position',
  strokeRepeat: 'stroke-repeat',
  strokeSize: 'stroke-size',
  strokeWidth: 'stroke-width',
  tabSize: 'tab-size',
  tableLayout: 'table-layout',
  textAlign: 'text-align',
  textAlignAll: 'text-align-all',
  textAlignLast: 'text-align-last',
  textCombineUpright: 'text-combine-upright',
  textDecoration: 'text-decoration',
  textDecorationColor: 'text-decoration-color',
  textDecorationLine: 'text-decoration-line',
  textDecorationSkip: 'text-decoration-skip',
  textDecorationStyle: 'text-decoration-style',
  textEmphasis: 'text-emphasis',
  textEmphasisColor: 'text-emphasis-color',
  textEmphasisPosition: 'text-emphasis-position',
  textEmphasisStyle: 'text-emphasis-style',
  textIndent: 'text-indent',
  textJustify: 'text-justify',
  textOrientation: 'text-orientation',
  textOverflow: 'text-overflow',
  textShadow: 'text-shadow',
  textSpaceCollapse: 'text-space-collapse',
  textSpaceTrim: 'text-space-trim',
  textSpacing: 'text-spacing',
  textTransform: 'text-transform',
  textUnderlinePosition: 'text-underline-position',
  textWrap: 'text-wrap',
  top: 'top',
  transform: 'transform',
  transformBox: 'transform-box',
  transformOrigin: 'transform-origin',
  transformStyle: 'transform-style',
  transition: 'transition',
  transitionDelay: 'transition-delay',
  transitionDuration: 'transition-duration',
  transitionProperty: 'transition-property',
  transitionTimingFunction: 'transition-timing-function',
  unicodeBidi: 'unicode-bidi',
  userSelect: 'user-select',
  verticalAlign: 'vertical-align',
  visibility: 'visibility',
  voiceBalance: 'voice-balance',
  voiceDuration: 'voice-duration',
  voiceFamily: 'voice-family',
  voicePitch: 'voice-pitch',
  voiceRange: 'voice-range',
  voiceRate: 'voice-rate',
  voiceStress: 'voice-stress',
  voiceVolume: 'voice-volume',
  volume: 'volume',
  whiteSpace: 'white-space',
  widows: 'widows',
  width: 'width',
  willChange: 'will-change',
  wordBreak: 'word-break',
  wordSpacing: 'word-spacing',
  wordWrap: 'word-wrap',
  wrapAfter: 'wrap-after',
  wrapBefore: 'wrap-before',
  wrapFlow: 'wrap-flow',
  wrapInside: 'wrap-inside',
  wrapThrough: 'wrap-through',
  writingMode: 'writing-mode',
  zIndex: 'z-index'
};
var win;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof global !== 'undefined') {
  win = global;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
}

var window$1 = win;
/**
 * @file [MoGaiCssProps] 魔改CssProps
 * @author [mzvast]
 * @email [mzvast@gmail.com]
 * @create date 2019-07-11 12:14
 */

function MoGaiCssProps(prop) {
  if (typeof prop === 'number') {
    return prop;
  }

  if (typeof prop === 'string') {
    // 兼容plugin
    var plugin = window$1['galacoMoGaiCssPlugin'];

    if (plugin && typeof plugin === 'function') {
      return plugin(1, prop);
    }
  }

  return prop;
}

function pickCSSProps(props) {
  var filteredProps;

  for (var prop in props) {
    if (prop in CSSProps) {
      if (!filteredProps) {
        filteredProps = {};
      }

      filteredProps[prop] = MoGaiCssProps(props[prop]);
    }
  }

  return filteredProps;
}

var dedupeClassName = function dedupeClassName(className) {
  return className && className.split(" ").filter(function (part, i, parts) {
    return i === parts.indexOf(part);
  }).join(" ");
};

function pickHTMLProps(props) {
  var filteredProps = {};

  for (var prop in props) {
    if (isPropValid(prop)) {
      filteredProps[prop] = props[prop];
    }
  }

  return filteredProps;
}

var BoxComponent = forwardRef(function (_a, ref) {
  var T = _a.use,
      props = __rest(_a, ["use"]);

  if (!T) return null;
  var style = pickCSSProps(props);

  if (typeof T === 'string') {
    var className = dedupeClassName(props.className);
    var allProps = Object.assign(pickHTMLProps(props), {
      className: className
    }, style ? {
      style: style
    } : {});
    return createElement(T, _assign({}, allProps, {
      ref: applyAllRefs(ref, props.elementRef)
    }));
  }

  return createElement(T, _assign({}, props, {
    ref: applyAllRefs(ref, props.elementRef),
    style: style
  }));
});
var Box = styled(BoxComponent)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: unset;\n    padding: unset;\n    border: unset;\n    background: unset;\n    font-family: inherit;\n    font-size: 100%;\n    box-sizing: border-box;\n    &:focus:not(:focus-visible) {\n        outline: none;\n    }\n    ", ";\n   \n"], ["\n    margin: unset;\n    padding: unset;\n    border: unset;\n    background: unset;\n    font-family: inherit;\n    font-size: 100%;\n    box-sizing: border-box;\n    &:focus:not(:focus-visible) {\n        outline: none;\n    }\n    ", ";\n   \n"])), theme$1('Box'));
var Box$1 = use(Box, 'div');
var templateObject_1;
var Block = styled(Box$1)(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    display: block;\n    ", ";\n"], ["\n    display: block;\n    ", ";\n"])), theme$1('Block'));
var Block$1 = use(Block, 'div');
var templateObject_1$1;
var Flex = styled(Box$1)(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n    display: flex;\n    ", ";\n"], ["\n    display: flex;\n    ", ";\n"])), theme$1('Flex'));
var Flex$1 = use(Flex, "div");
var templateObject_1$2;
var Grid = styled(Box$1)(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n    display: grid;\n    ", ";\n"], ["\n    display: grid;\n    ", ";\n"])), theme$1('Grid'));
var Grid$1 = use(Grid, "div");
var templateObject_1$3;
var Inline = styled(Box$1)(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n    display: inline;\n    ", ";\n"], ["\n    display: inline;\n    ", ";\n"])), theme$1('Inline'));
var Inline$1 = use(Inline, 'div');
var templateObject_1$4;
var InlineBlock = styled(Box$1)(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n    display: inline-block;\n    ", ";\n"], ["\n    display: inline-block;\n    ", ";\n"])), theme$1('InlineBlock'));
var InlineBlock$1 = use(InlineBlock, 'div');
var templateObject_1$5;
var InlineFlex = styled(Box$1)(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n    display: inline-flex;\n    ", ";\n"], ["\n    display: inline-flex;\n    ", ";\n"])), theme$1("InlineFlex"));
var InlineFlex$1 = use(InlineFlex, 'div');
var templateObject_1$6;
/**
 * @file [generateColorVariants]
 * @author [mzvast]
 * @email [mzvast@gmail.com]
 * @create date 2019-02-23 13:49:00
 */

function generateColorVariants(_a) {
  var _b;

  var color = _a.color,
      paletteKey = _a.paletteKey,
      paletteOverrides = _a.paletteOverrides;
  return _assign((_b = {}, _b[paletteKey + "100"] = tint(0.7, color), _b[paletteKey + "200"] = tint(0.5, color), _b[paletteKey + "300"] = tint(0.3, color), _b[paletteKey + "400"] = tint(0.1, color), _b[paletteKey] = color, _b[paletteKey + "500"] = color, _b[paletteKey + "600"] = shade(0.1, color), _b[paletteKey + "700"] = shade(0.3, color), _b[paletteKey + "800"] = shade(0.5, color), _b[paletteKey + "900"] = shade(0.7, color), _b[paletteKey + "Tint"] = tint(0.7, color), _b[paletteKey + "Inverted"] = readableColor(color), _b[paletteKey + "TintInverted"] = shade(0.5, color), _b), paletteOverrides ? paletteOverrides({
    color: color
  }) : {});
}
/**
 * @file [generateTextVariants]
 * @author [mzvast]
 * @email [mzvast@gmail.com]
 * @create date 2019-02-23 13:51:52
 */


function generateTextVariants(textColor) {
  return {
    text100: lighten(0.2, textColor),
    text200: lighten(0.15, textColor),
    text300: lighten(0.1, textColor),
    text400: lighten(0.05, textColor),
    text: textColor,
    textTint: tint(0.8, textColor),
    textInverted: readableColor(textColor),
    textTintInverted: shade(0.3, textColor)
  };
}

var defaultPalette = {
  text: '#435a6f',
  primary: '#444bc9',
  secondary: '#793fb2',
  info: '#35709e',
  success: '#2c8453',
  danger: '#c9444d',
  warning: '#f2a100'
};

var palette = function palette(overrides) {
  return _assign({}, defaultPalette, generateTextVariants(_get(overrides, 'palette.text') || defaultPalette.text), {
    black: 'black',
    black500: 'black',
    white: 'white',
    white500: 'white',
    white600: darken(0.03, 'white'),
    white700: darken(0.05, 'white'),
    white800: darken(0.1, 'white'),
    white900: darken(0.15, 'white'),
    gray100: lighten(0.2, 'gray'),
    gray200: lighten(0.15, 'gray'),
    gray300: lighten(0.1, 'gray'),
    gray400: lighten(0.05, 'gray'),
    gray: 'gray',
    gray500: 'gray',
    gray600: darken(0.05, 'gray'),
    gray700: darken(0.1, 'gray'),
    gray800: darken(0.15, 'gray'),
    gray900: darken(0.2, 'gray'),
    default: darken(0.01, 'white'),
    defaultInverted: '#435a6f'
  }, generateColorVariants({
    paletteKey: 'primary',
    color: _get(overrides, "palette.primary") || defaultPalette.primary
  }), generateColorVariants({
    paletteKey: 'secondary',
    color: _get(overrides, "palette.secondary") || defaultPalette.secondary
  }), generateColorVariants({
    paletteKey: 'info',
    color: _get(overrides, "palette.info") || defaultPalette.info
  }), generateColorVariants({
    paletteKey: 'success',
    color: _get(overrides, "palette.success") || defaultPalette.success
  }), generateColorVariants({
    paletteKey: 'danger',
    color: _get(overrides, "palette.danger") || defaultPalette.danger
  }), generateColorVariants({
    paletteKey: 'warning',
    color: _get(overrides, "palette.warning") || defaultPalette.warning,
    paletteOverrides: function paletteOverrides(_a) {
      var color = _a.color;
      return {
        warningTintInverted: shade(0.7, color)
      };
    }
  }), _get(overrides, 'palette', {}));
};

function theme(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }

  console.log(overrides);
  return _assign({}, overrides, {
    // global: global(overrides),
    palette: palette(overrides)
  });
}

var buildColorFromPalette = function buildColorFromPalette(property) {
  return function (_a) {
    var theme = _a.theme,
        props = __rest(_a, ["theme"]); // @ts-ignore


    var color = theme.palette[props[_camelCase(property)]];

    if (typeof color === 'function') {
      color = color(props);
    }

    if (!color) return;
    return property + ": " + color + " !important;";
  };
}; // @ts-ignore


var boxTheme = {
  Box: css(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n        /* If the color is one from the palette, use it. E.g. background-color=\"primary\" */\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n    "], ["\n        /* If the color is one from the palette, use it. E.g. background-color=\"primary\" */\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n        ", ";\n    "])), buildColorFromPalette('color'), buildColorFromPalette('background-color'), buildColorFromPalette('border-block-end-color'), buildColorFromPalette('border-block-start-color'), buildColorFromPalette('border-bottom-color'), buildColorFromPalette('border-color'), buildColorFromPalette('border-inline-end-color'), buildColorFromPalette('border-inline-start-color'), buildColorFromPalette('border-left-color'), buildColorFromPalette('border-right-color'), buildColorFromPalette('border-top-color'), buildColorFromPalette('border-bottom-color'), buildColorFromPalette('caret-color'), buildColorFromPalette('column-rule-color'), buildColorFromPalette('outline-color'), buildColorFromPalette('text-decoration-color'), buildColorFromPalette('text-emphasis-color'))
};
var templateObject_1$7; //  ${props => buildSpacingFromTheme('margin', props)};
//         ${props => buildSpacingFromTheme('margin-left', props)};
//         ${props => buildSpacingFromTheme('margin-right', props)};
//         ${props => buildSpacingFromTheme('margin-top', props)};
//         ${props => buildSpacingFromTheme('margin-bottom', props)};
//         ${props => buildSpacingFromTheme('padding', props)};
//         ${props => buildSpacingFromTheme('padding-left', props)};
//         ${props => buildSpacingFromTheme('padding-right', props)};
//         ${props => buildSpacingFromTheme('padding-top', props)};
//         ${props => buildSpacingFromTheme('padding-bottom', props)};
//         ${props => buildFontSizeFromTheme('font-size', props)};
//         ${props => buildFontWeightFromTheme('font-weight', props)};

var loadTheme = function loadTheme(_a) {
  var _theme = _a.theme,
      isStandalone = _a.isStandalone;
  var theme$1 = theme(_theme);

  if (isStandalone && _theme) {
    theme$1 = _theme;
  }

  return _assign({}, boxTheme, {
    palette: theme$1 && theme$1.palette ? theme$1.palette : {}
  });
};

var Provider =
/** @class */
function (_super) {
  __extends(Provider, _super);

  function Provider() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      theme: loadTheme({
        theme: _this.props.theme,
        isStandalone: _this.props.isStandalone
      })
    };

    _this.render = function () {
      var children = _this.props.children;
      var theme = _this.state.theme;
      return createElement(ThemeProvider, {
        theme: theme
      }, createElement(Fragment, null, children));
    };

    return _this;
  }

  Provider.propTypes = {
    children: node.isRequired,
    isStandalone: bool,
    theme: object
  };
  Provider.defaultProps = {
    isStandalone: false,
    theme: {}
  };
  return Provider;
}(Component);
/**
 * @file [getPx2vw]
 * @author [mzvast]
 * @email [mzvast@gmail.com]
 * @create date 2019-06-27 16:17
 */

/**
 * getPx2vw
 * @param pWidth 设计稿宽度，单位px
 */


function getPx2vw(pWidth) {
  // -2 /* post-process context */
  // -1 /* preparation context */
  // 0  /* newline context */
  //
  // 1  /* property context */
  // 2  /* selector block context */
  // 3  /* @at-rule block context */

  /**
   * px2vw
   * @param context
   * @param content
   * @param selectors
   * @param parent
   * @param line
   * @param column
   * @param length
   */
  function px2vw(context, content, selectors, parent, line, column, length) {
    // console.log('plugin::context:,', context, ',content:', content);
    switch (context) {
      case 1:
        // console.log('plugin::1content', content);
        return content.replace(/([0-9.]+)px/g, function (match, p1) {
          // console.log('plugin::match,p1', match, p1);
          var val = Number(p1);

          if (val > 1) {
            return val * 100 / pWidth + 'vw';
          }

          if (val === 0) {
            return '0';
          } // 0<val<=1


          if (window$1 && window$1.devicePixelRatio > 1) {
            return val / devicePixelRatio + 'px';
          }

          return '1px';
        });
    }
  }

  window$1['galacoMoGaiCssPlugin'] = px2vw; // MoGai Hook

  return px2vw;
}
/**
 * @file [test1px]
 * @author [mzvast]
 * @email [mzvast@gmail.com]
 * @create date 2019-06-25 21:24
 */


function test1px() {
  if (window$1.devicePixelRatio && devicePixelRatio >= 2) {
    var testElem = document.createElement('div');
    testElem.style.border = '.5px solid transparent';
    document.body.appendChild(testElem);

    if (testElem.offsetHeight == 1) {
      document.querySelector('html').classList.add('hairlines');
    }

    document.body.removeChild(testElem);
  }
}
/**
 * @file [requiredParam]
 * @author [mzvast]
 * @email [mzvast@gmail.com]
 * @create date 2019-07-25 11:33
 */

/* eslint-disable max-len,babel/new-cap,operator-linebreak,fecs-export-on-declare,space-before-function-paren */

/**
 * 捕获必须参数的缺失
 * @param requiredParam
 */


function requiredParam(requiredParam) {
  var requiredParamError = new Error("Required parameter, \"" + requiredParam + "\" is missing."); // preserve original stack trace

  if (typeof Error['captureStackTrace'] === 'function') {
    Error['captureStackTrace'](requiredParamError, requiredParam);
  }

  throw requiredParamError;
}
/**
 * @file [useLockBodyScroll]
 * @author [mzvast]
 * @email [mzvast@gmail.com]
 * @create date 2020-09-22 15:29:32
 */


function useLockBodyScroll() {
  useLayoutEffect(function () {
    // Get original body overflow
    var originalStyle = window.getComputedStyle(document.body).overflow; // Prevent scrolling on mount

    document.body.style.overflow = 'hidden'; // Re-enable scrolling when component unmounts

    return function () {
      document.body.style.overflow = originalStyle;
    };
  }, []); // Empty array ensures effect is only run on mount and unmount
}
/**
 * 多行省略
 * @param row
 */


var Ellipsis = function Ellipsis(row) {
  if (row === void 0) {
    row = 1;
  }

  return styled(Box$1)(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n    overflow: hidden;\n    \xA0text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: ", ";\n"], ["\n    overflow: hidden;\n    \xA0text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: ", ";\n"])), row);
};

var templateObject_1$8;
/**
 * @file [useModalState]
 * @author [mzvast]
 * @email [mzvast@gmail.com]
 * @create date 2019-07-30 12:59
 */

function useHiddenState() {
  var _a = useState(false),
      visible = _a[0],
      setVisible = _a[1];

  var show = useCallback(function () {
    setVisible(true);
  }, []);
  var hide = useCallback(function () {
    setVisible(false);
  }, []);
  var toggle = useCallback(function () {
    setVisible(function (v) {
      return !v;
    });
  }, []);
  return {
    visible: visible,
    show: show,
    hide: hide,
    toggle: toggle
  };
}

var Wrap = styled(Box$1)(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n    position: fixed;\n    z-index: 999;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n"], ["\n    position: fixed;\n    z-index: 999;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n"])));
var Mask = styled(Box$1)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: fixed;\n    z-index: 999;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.6);\n"], ["\n    position: fixed;\n    z-index: 999;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.6);\n"])));
var ModalWrap = styled(Box$1)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: fixed;\n    z-index: 1000;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    overflow: auto;\n    outline: 0;\n    ::before {\n        display: inline-block;\n        width: 0;\n        height: 100%;\n        vertical-align: middle;\n        content: '';\n    }\n    /* pointer-events: none; */\n"], ["\n    position: fixed;\n    z-index: 1000;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    overflow: auto;\n    outline: 0;\n    ::before {\n        display: inline-block;\n        width: 0;\n        height: 100%;\n        vertical-align: middle;\n        content: '';\n    }\n    /* pointer-events: none; */\n"])));
var ContentOuter = styled(Box$1)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: relative;\n    top: 0;\n    left: 50%;\n    display: inline-block;\n    text-align: left;\n    vertical-align: middle;\n    transform: translate(-50%, 0);\n    pointer-events: none;\n"], ["\n    position: relative;\n    top: 0;\n    left: 50%;\n    display: inline-block;\n    text-align: left;\n    vertical-align: middle;\n    transform: translate(-50%, 0);\n    pointer-events: none;\n"])));
var ContentInner = styled(Box$1)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: relative;\n    pointer-events: auto;\n"], ["\n    position: relative;\n    pointer-events: auto;\n"]))); // API 借鉴 https://ant.design/components/modal-cn/

function ModalContent(_a) {
  var children = _a.children,
      contentStyle = _a.contentStyle;
  return React__default.createElement(ContentOuter, _assign({}, contentStyle, {
    className: "galaco-modal-content"
  }), React__default.createElement(ContentInner, null, children));
}

function BodyLockWrap() {
  useLockBodyScroll();
  return null;
}

function Modal(_a) {
  var visible = _a.visible,
      _b = _a.maskClosable,
      maskClosable = _b === void 0 ? false : _b,
      _c = _a.maskStyle,
      maskStyle = _c === void 0 ? {} : _c,
      _d = _a.contentStyle,
      contentStyle = _d === void 0 ? {} : _d,
      _e = _a.mask,
      mask = _e === void 0 ? true : _e,
      hide = _a.hide,
      show = _a.show,
      toggle = _a.toggle,
      children = _a.children,
      _f = _a.useLock,
      useLock = _f === void 0 ? true : _f;

  var onMaskClick = function onMaskClick(e) {
    if (!maskClosable) return;
    if (!e.target.classList.contains('galaco-modal-wrap')) return;
    hide && hide();
  };

  return React__default.createElement(React__default.Fragment, null, visible && ReactDOM.createPortal(React__default.createElement(Wrap, {
    className: "galaco-modal-root"
  }, mask && React__default.createElement(Mask, _assign({
    className: "galaco-modal-mask"
  }, maskStyle)), React__default.createElement(ModalWrap, {
    className: "galaco-modal-wrap",
    onClick: onMaskClick
  }, useLock && React__default.createElement(BodyLockWrap, null), React__default.createElement(ModalContent, {
    contentStyle: contentStyle
  }, children))), document.body));
}

var templateObject_1$9, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
/**
 * @file [ModalState]
 * @author [mzvast]
 * @email [mzvast@gmail.com]
 * @create date 2019-07-30 13:07
 */

function useModalState() {
  return useHiddenState();
}
/**
 * @file [WithModal]
 * @author [mzvast]
 * @email [mzvast@gmail.com]
 * @create date 2019-07-30 13:50
 */


function WithModal(_a) {
  var children = _a.children;
  var modal = useModalState();
  return children(modal);
}

export { Block$1 as Block, Box$1 as Box, Ellipsis, Flex$1 as Flex, Grid$1 as Grid, Inline$1 as Inline, InlineBlock$1 as InlineBlock, InlineFlex$1 as InlineFlex, Modal, Provider as ThemeProvider, WithModal, getPx2vw, requiredParam, test1px, useHiddenState, useLockBodyScroll, useModalState };